import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import WithShortCourseLicenseData from '../DataHOCs/WithShortCourseLicenseData';
import Strings from '../../../../app/shared/Strings';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    licenses: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {};

const NEW_LICENSE_TOKEN = 'new';

class AddLicenseForUserModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            addActionId: null,
            requestError: null,
            selectedLicenseToken: NEW_LICENSE_TOKEN,
            selectedLicenseTypeToken: '',
            userEmail: '',
            instructorEmail: '',
        };
        this.onAddLicense = this.onAddLicense.bind(this);
        this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAddLicense() {
        if (this.state.selectedLicenseToken === NEW_LICENSE_TOKEN) {
            return;
        }
        else {
            const actionId = uuid.v4();
            this.setState({ addActionId: actionId }, () => {
                ShortCourseActions.adminAddLicenseForUser(actionId, {
                    licenseToken: this.state.selectedLicenseToken,
                    userEmail: this.state.userEmail,
                    instructorEmail: this.state.instructorEmail,
                });
            });
        }
    }

    onSelectLicense(token) {
        let updatedState = { selectedLicenseToken: token };
        if (token === NEW_LICENSE_TOKEN) {
            updatedState = {
                ...updatedState,
                userEmail: '',
                instructorEmail: '',
                selectedLicenseTypeToken: '',
            };
        }
        else {
            const license = this.props.licenses[token];
            updatedState = {
                ...updatedState,
                instructorEmail: license.license_type_token === Globals.ecommerce.course_license_types.INSTITUTION ? this.state.instructorEmail : '',
                selectedLicenseTypeToken: license.license_type_token,
            };
        }

        this.setState(updatedState);
    }

    onShortCourseStoreChange(newState) {
        if (this.state.addActionId === newState.action.id) {
            if (!newState.action.error) {
                this.setState({ requestError: null, addActionId: null }, () => {
                    this.props.onClose();
                });
            }
            else {
                this.setState({ requestError: newState.action.error, addActionId: null });
            }
        }
    }

    render() {
        const licenseOptions = Object.values(this.props.licenses).map((license) => {
            return {
                token: license.token,
                title: license.token,
                selected: license.token === this.state.selectedLicenseToken
            };
        });

        licenseOptions.unshift({
            token: NEW_LICENSE_TOKEN,
            title: Strings['en'].short_course.modals.add_user_license.SELECT_DEFAULT,
            selected: NEW_LICENSE_TOKEN === this.state.selectedLicenseToken,
        });

        return (
            <Modal
                show
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{Strings['en'].short_course.modals.add_user_license.MODAL_HEADER}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox error={this.state.requestError} />
                    <Form>
                    <Form.Label>{Strings['en'].short_course.modals.add_user_license.LICENSE_SELECT_LBL}</Form.Label>
                        <Form.Group controlId="mzl-ucl-license-select">
                            <Form.Control
                                as="select"
                                onChange={(e) => this.onSelectLicense(e.target.value)}
                                disabled={!!this.state.addActionId}
                            >
                                {licenseOptions.map((license) => {
                                    return (
                                        <option key={license.token} value={license.token}>{license.title}</option>
                                    );
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="mzl-ucl-email">
                            <Form.Label>{Strings['en'].short_course.modals.add_user_license.USER_EMAIL}</Form.Label>
                            <Form.Control
                                type="text"
                                value={this.state.userEmail}
                                onChange={(e) => this.setState({ userEmail: e.target.value })}
                            />
                        </Form.Group>
                        {(this.state.selectedLicenseTypeToken === Globals.ecommerce.course_license_types.INSTITUTION) &&
                            <Form.Group controlId="mzl-ucl-inst-email">
                                <Form.Label>{Strings['en'].short_course.modals.add_user_license.INSTRUCTOR_EMAIL}</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={this.state.instructorEmail}
                                    onChange={(e) => this.setState({ instructorEmail: e.target.value })}
                                />
                            </Form.Group>
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={this.onAddLicense}
                        disabled={!!this.state.addActionId || this.state.selectedLicenseToken === NEW_LICENSE_TOKEN }
                    >
                        {Strings['en'].common.ADD}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

AddLicenseForUserModal.propTypes = propTypes;
AddLicenseForUserModal.defaultProps = defaultProps;

export default WithShortCourseLicenseData(AddLicenseForUserModal);